{
  "messages": {
    "rescheduledOnce": "Reagendado uma vez",
    "rescheduledTwice": "Reagendado duas vezes",
    "rescheduledCountTimes": "Reagendado {count} vezes"
  }
}
